import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Logo } from "../components/Logo";
import { IMG_AUTH_BG } from "../lib/images";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("Password must be at least 8 characters.");
    if (password !== confirm) return setError("Passwords do not match.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-80px)] grid grid-cols-1 lg:grid-cols-2" data-testid="reset-password-page">
      <div className="hidden lg:block relative">
        <img src={IMG_AUTH_BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-midnight-black/50" />
      </div>
      <div className="flex items-center justify-center px-6 py-16 bg-clean-white">
        <div className="w-full max-w-sm">
          <div className="bg-midnight-black rounded-xl px-4 py-3 inline-block mb-10">
            <Logo className="h-9" />
          </div>
          <h1 className="font-extrabold uppercase text-2xl tracking-tight mb-2">Reset Password</h1>
          <p className="text-midnight-black/60 font-medium mb-8 text-sm">Choose a new password for your account.</p>
          {!token ? (
            <p className="text-sm font-bold text-red-600" data-testid="reset-password-missing-token">
              This reset link is missing its token. Please request a new one.
            </p>
          ) : done ? (
            <p className="text-sm font-bold text-midnight-black/80" data-testid="reset-password-success-message">
              Password updated. Redirecting you to log in...
            </p>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="reset-password-form">
              <Input data-testid="reset-password-new-input" type="password" placeholder="New password" required value={password} onChange={(e) => setPassword(e.target.value)} />
              <Input data-testid="reset-password-confirm-input" type="password" placeholder="Confirm new password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} />
              {error && (
                <p className="text-sm font-bold text-red-600" data-testid="reset-password-error">
                  {error}
                </p>
              )}
              <Button type="submit" data-testid="reset-password-submit-button" disabled={loading} className="w-full bg-stranger-orange hover:bg-orange-600 text-clean-white font-bold tracking-wide rounded-full py-6">
                {loading ? "Updating..." : "UPDATE PASSWORD"}
              </Button>
            </form>
          )}
          <p className="text-sm font-medium text-midnight-black/60 mt-6">
            <Link to="/login" data-testid="back-to-login-link" className="text-stranger-orange font-bold hover:underline">
              Back to log in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
